import { catchallErrorMessage } from 'sharedFrontendBackend/constants';

const utilityFunctions = {}

utilityFunctions.install = function (Vue, options) {
// export default {
	// install(Vue, options) {
		Vue.prototype.$leftpad = (str, len, ch) => {
			str = String(str);
			var i = -1;
			if (!ch && ch !== 0) ch = ' ';
			len = len - str.length;
			while (++i < len) {
				str = ch + str;
			}
			return str
		};

		Vue.prototype.$currencyOnly = function(e){
			if ((e.key == 'Backspace' || e.key == 'Delete' || e.key == 'ArrowLeft' || e.key == 'ArrowRight' || e.key == 'Tab') ||
				(e.key >= 0 && e.key <= 9) ||
				e.key == '.'){

				// Check to see if this is the first "." or not
				if (e.key == '.' && (e.currentTarget.value.indexOf('.') != -1 || e.currentTarget.value == '' || e.currentTarget.value == null)){
					return e.preventDefault();
				// Check that if a number is being typed, there is no more than one number after a decimal point
				// (once there are two, no more digits are allowed). Any number of digits may preceed the decimal
				} else if ((e.key >= 0 && e.key <= 9) && !(/^\d*(\.\d{1})?$/.test(e.currentTarget.value))) {
					return e.preventDefault();
				} else {
					return;
				}
			} else {
				e.preventDefault();
			}
		}

		Vue.prototype.$positiveWholeNumberOnly = function(e){
			if ((e.key == 'Backspace' || e.key == 'Delete' || e.key == 'ArrowLeft' || e.key == 'ArrowRight' || e.key == 'Tab') ||
				(e.key >= 0 && e.key <= 9)){
				return;
			} else {
				return e.preventDefault();
			}
		}

		Vue.prototype.$catchallErrorMessage = `Something has gone very wrong. ${catchallErrorMessage}`;
	}
// }

export default utilityFunctions;